import { useEffect } from "react";
import { useSetRecoilState } from "recoil";

import {
  DirectionEnum,
  lastChosenBulkCreateBookingDirectionAtom,
} from "@ryde/shared";

export const useBulkBookingFormEffects = ({
  direction,
}: {
  direction: DirectionEnum;
}) => {
  const setLastChosenBulkCreateBookingDirection = useSetRecoilState(
    lastChosenBulkCreateBookingDirectionAtom,
  );
  useEffect(() => {
    setLastChosenBulkCreateBookingDirection(direction);
  }, [direction, setLastChosenBulkCreateBookingDirection]);
};
